/*
  Keeps a product card's price row in step with its variant <select>.

  The card markup (munchief-product-tile, the munchief-product-card block and
  munchief-product-carousel) renders the default variant's price server-side;
  each <option> carries data-price / data-compare / data-save with the
  already-formatted money strings, so this script never formats currency.

  Delegated on document so it survives Horizon's section morphs.
*/
(function () {
  'use strict';

  function text(className, value) {
    var el = document.createElement('span');
    el.className = className;
    el.textContent = value;
    return el;
  }

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('.product-card select.select__input[name="id"]')) return;

    var card = select.closest('.product-card');
    var price = card && card.querySelector('.price');
    var option = select.options[select.selectedIndex];
    if (!price || !option || !option.dataset.price) return;

    price.textContent = '';
    price.appendChild(text('price__sale', option.dataset.price));
    if (option.dataset.compare) {
      price.appendChild(text('price__compare', option.dataset.compare));
      price.appendChild(text('badge badge--green', 'Save ' + option.dataset.save));
    }
  });
})();
